import React from "react";
import "./DashLoader.css"; // Create and style this CSS file as needed

const DashLoader = () => {
  return (
    <div className="dash-small-loader">
      <div className="dash-loader-circle"></div>
    </div>
  );
};

export default DashLoader;
